import { render, staticRenderFns } from "./DelayItem.vue?vue&type=template&id=9b5b0bd2&scoped=true&"
import script from "./DelayItem.vue?vue&type=script&lang=js&"
export * from "./DelayItem.vue?vue&type=script&lang=js&"
import style0 from "./DelayItem.vue?vue&type=style&index=0&id=9b5b0bd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5b0bd2",
  null
  
)

export default component.exports